<template>
  <section id="lc-progress" class="demo-section">

    <h2
      id="lc-loading-indicator"
      class="demo-section__title"
    >&lt;lc-loading-indicator/&gt;</h2>

    <lc-loading-indicator />

  </section>
</template>

<script>
import LcLoadingIndicator from "@/components/LcLoadingIndicator";

export default {
  name: "lc-progress-demo",
  components: {
    LcLoadingIndicator
  }
};
</script>
